import { set } from 'region-shortcut';

export default key => value => set(key, value);



// WEBPACK FOOTER //
// ./src/shared/setFactory.js